module.exports = __webpack_public_path__ + "static/media/Primate-House8.d54949b5.jpg";